import React from "react";
import { IconProps } from "./IconProps";

const HelpCircle: React.FC<IconProps> = ({
    size = 20,
    color = "#F7F9F9",
    ...props
}) => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={size}
            height={size}
            viewBox="0 0 21 21"
            fill="none"
            {...props}
        >
            <g clipPath="url(#clip0_4752_3292)">
                <path
                    d="M8.55102 7.60125C8.74587 7.04393 9.13167 6.57355 9.6401 6.27342C10.1485 5.9733 10.7468 5.8628 11.3289 5.96149C11.9109 6.06018 12.4393 6.3617 12.8204 6.81263C13.2015 7.26357 13.4107 7.83483 13.411 8.42523C13.4142 10.0919 10.9158 10.93 10.9158 10.93M10.9889 14.2632L10.9972 14.2632M19.3141 10.0805C19.323 14.6829 15.5992 18.421 10.9969 18.4299C6.39451 18.4388 2.65637 14.715 2.64751 10.1126C2.63865 5.51025 6.36242 1.77211 10.9648 1.76325C15.5672 1.7544 19.3053 5.47817 19.3141 10.0805Z"
                    stroke={color}
                    strokeWidth="1.67"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                />
            </g>
            <defs>
                <clipPath id="clip0_4752_3292">
                    <rect
                        width={size}
                        height={size}
                        fill={color}
                        transform="translate(0.961548 0.115723) rotate(-0.110297)"
                    />
                </clipPath>
            </defs>
        </svg>
    );
};

export default HelpCircle;
